export { FacebookIcon } from './Facebook';
export { InstagramIcon } from './Instagram';
export { LinkedinIcon } from './Linkedin';
export { PinterestIcon } from './Pinterest';
export { SupportIcon } from './Support';
